module.exports = __webpack_public_path__ + "static/pulsio_box-5c01c6c19820c06138976e0ddcff4d6c.png";